var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.chartData.length)?_c('div',{staticClass:"color-dark"},[_c('h2',{staticClass:"h4 m-0 mb-3 font-weight-semi-bold"},[_vm._v("Images Count")]),_vm._v(" "),_c('div',{ref:"reportChart"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }